export enum PictureDesktopNames {
  ImgLargeDesk = 'imgLargeDesk',
  ImgDesk = 'imgDesk',
  ImgTablet = 'imgTablet',
  ImgMobile = 'imgMobile',
}
